// 공통 직무 및 전문분야 옵션 정의

export interface JobCategory {
  category: string
  jobs: readonly string[]
  allowCustomSpecialty?: boolean
}

export const OTHER_CATEGORY_LABEL = '기타'

export const JOB_CATEGORIES: readonly JobCategory[] = [
  {
    category: '개발',
    jobs: [
      '웹 프론트엔드 개발',
      '웹 퍼블리싱',
      '백엔드/서버 개발',
      '풀스택 개발',
      'iOS 앱 개발',
      '안드로이드 앱 개발',
      '크로스플랫폼 앱 개발 (Flutter/RN)',
      'DevOps/인프라',
      '게임 개발',
      '데이터 엔지니어링',
      '인공지능/머신러닝 (AI/ML)',
      '블록체인',
      '임베디드/IoT',
      'QA/테스트 엔지니어',
      '응용 프로그램 개발 (데스크탑)',
    ],
  },
  {
    category: '디자인',
    jobs: [
      '웹/모바일 디자인 (UI/UX)',
      '브랜드 디자인 (BI/CI)',
      '그래픽 디자인',
      '제품/패키지 디자인',
      '영상/모션 그래픽',
      '일러스트/캐릭터',
      '3D 디자인',
      '프레젠테이션 디자인',
    ],
  },
  {
    category: '기획/PM',
    jobs: [
      '서비스 기획 (웹/앱)',
      'PM/PO (프로덕트 매니저/오너)',
      '프로젝트 관리 (SI/에이전시)',
      '게임 기획',
      '비즈니스/사업 기획',
    ],
  },
  {
    category: '마케팅/광고',
    jobs: [
      '퍼포먼스 마케팅',
      '콘텐츠 마케팅',
      '브랜드 마케팅',
      '검색 최적화 (SEO)',
      '바이럴/SNS 마케팅',
      'CRM 마케팅',
      '광고 집행/운영',
    ],
  },
  {
    category: '콘텐츠/미디어',
    jobs: [
      '영상 편집/제작',
      '영상 촬영',
      '사진 촬영/보정',
      '카피라이팅/글쓰기',
      '블로그/포스팅',
      '음향/내레이션',
    ],
  },
  {
    category: '번역/통역',
    jobs: [
      '일반 번역',
      '비즈니스/전문 번역',
      '영상 번역',
      '통역',
    ],
  },
  {
    category: '데이터',
    jobs: [
      '데이터 분석 (Data Analyst)',
      '데이터 사이언스 (Data Scientist)',
      '데이터 시각화',
    ],
  },
  {
    category: '경영/비즈니스',
    jobs: [
      '사업계획서/제안서',
      '경영 컨설팅',
      '시장 조사/리서치',
      '인사/채용 (HR)',
      '재무/회계',
      '법률/특허',
    ],
  },
] as const

export const MAX_MAIN_JOB_SELECTION = 2

// 플랫한 직무 목록 (프로필 업데이트용) - 중복 제거
export const JOB_OPTIONS: string[] = Array.from(
  new Set(JOB_CATEGORIES.flatMap((cat) => cat.jobs))
)

// 전문분야 옵션 (전체 목록)
export const EXPERTISE_OPTIONS: string[] = JOB_OPTIONS

export const SPECIALTY_OPTIONS_BY_CATEGORY: Record<string, readonly string[]> =
  JOB_CATEGORIES.reduce((acc, category) => {
    acc[category.category] = category.jobs
    return acc
  }, {} as Record<string, readonly string[]>)

export const SPECIALTY_TO_CATEGORY_MAP: Record<string, string> =
  JOB_CATEGORIES.reduce((acc, category) => {
    category.jobs.forEach((job) => {
      acc[job] = category.category
    })
    return acc
  }, {} as Record<string, string>)

export const CATEGORY_ALLOW_CUSTOM_SPECIALTY: Record<string, boolean> =
  JOB_CATEGORIES.reduce((acc, category) => {
    acc[category.category] = Boolean(category.allowCustomSpecialty)
    return acc
  }, {} as Record<string, boolean>)
